<template>
  <div class="dashboard-container">
    <div class="select-interval row no-gutters justify-content-md-end justify-content-start">
      <div class="primary-input-container from col-md-auto col-12 my-3">
        <p class="primary-input-title">From</p>
        <div class="primary-select-wrapper">
          <date-picker
            v-model="interval.from"
            calendar-class="calendar-class"
            format="yyyy-MM-dd"
            wrapper-class="date-wrapper"
            placeholder="YYYY MM DD"
            input-class="date-picker"
            @selected="selectedFrom"
            :disabledDates="interval.fromDisabledDates"
          />
          <img src="../../../assets/Icon/Arrow/Down.svg" class="icon-down" alt />
        </div>
      </div>
      <div class="primary-input-container col-md-auto col-12 my-md-3">
        <p class="primary-input-title">To</p>
        <div class="primary-select-wrapper">
          <date-picker
            v-model="interval.to"
            calendar-class="calendar-class"
            format="yyyy-MM-dd"
            wrapper-class="date-wrapper"
            placeholder="YYYY MM DD"
            input-class="date-picker"
            @selected="selectedTo"
            :disabledDates="interval.toDisabledDates"
          />
          <img src="../../../assets/Icon/Arrow/Down.svg" class="icon-down" alt />
        </div>
      </div>
    </div>
    <loader :loading="loading" v-if="loading" />
    <div class="chart-container" v-if="!loading">
      <card-componet class="first">
        <alert-daily-line
          :options="{responsive: false, maintainAspectRatio: false}"
          :width="1000"
          :height="280"
          :data="chartData"
        ></alert-daily-line>
        <div class="search-container">
          <search-input
            class="search-input"
            type="text"
            v-model="companyName"
            placeholder="Search"
          />
          <secondary-button @click.native="getSmsReports" class="secondary-button">Filter</secondary-button>
        </div>
        <div class="resellers-table table-header">
          <div>
            <span>Number</span>
          </div>
          <div>
            <span>SMS</span>
          </div>
        </div>
        <div v-for="(alert, k) in alerts" :key="k" class="resellers-table table-body">
          <div>
            <span>{{alert.companyName}}</span>
          </div>
          <div>
            <span>{{alert.smsCount}}</span>
          </div>
        </div>
        <p @click="showMore" class="pagination-link">Show more</p>
      </card-componet>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    AlertDailyLine: () => import("@/components/Charts/Alert/AlertDailyLine"),
    CardComponet: () => import("@/components/CardComponent.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    DatePicker: () => import("vuejs-datepicker"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    interval: {
      from: null,
      to: null,
      length: null,
      fromDisabledDates: {
        from: null,
      },
      toDisabledDates: {
        from: null,
        to: null,
      },
    },
    alerts: [],
    perPage: 10,
    companyName: "",
    resellers: [
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 },
      { company: "Lou Haynes", date: "06 Nov 2018", sms: 97322 },
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 },
    ],
    loading: true,
  }),
  computed: {
    ...mapGetters({}),
    chartData() {
      const from = this.interval.from;
      const to = this.interval.to;

      const diff = to.getTime() - from.getTime();

      const millisInDay = 1000 * 60 * 60 * 24;

      const days = Math.round(diff / millisInDay);

      let arrDate = [];
      let smsCountValues = [];

      for (let i = 0, date; i <= days; i++) {
        date = new Date(from.getTime() + i * millisInDay);
        arrDate[i] = date.getDate();
        smsCountValues[i] = 0;

        for (let j = 0, t; j < this.alerts.length; j++) {
          t = new Date(this.alerts[j].date);

          if (t.getTime() === date.getTime()) {
            smsCountValues[i] = this.alerts[j].smsCount;
            break;
          }
        }
      }

      return { arrDate, smsCountValues };
    },
  },
  created: function () {
    const date = new Date();

    const year = date.getFullYear();
    const month = date.getMonth();
    const lastDay = this.daysInMonth(year, month);

    const from = new Date(year, month, 1);
    const to = new Date(year, month, lastDay);

    const millisInDay = 1000 * 60 * 60 * 24;

    this.interval.from = from;
    this.interval.to = to;
    this.interval.length =
      Math.round((to.getTime() - from.getTime()) / millisInDay) + 1;
    this.interval.fromDisabledDates.from = to;
    this.interval.toDisabledDates.from = to;
    this.interval.toDisabledDates.to = new Date(from.getTime() + millisInDay);

    setTimeout(() => {
      this.getSmsReports();
    }, 500);
  },
  methods: {
    ...mapActions({
      viewSmsReport: "smses/",
      getSmsReport: "smses/getSmsReport",
    }),
    daysInMonth(year, month) {
      return new Date(year, month + 1, 0).getDate();
    },
    transformAlerts(i, k) {
      return {
        companyName: i.company_name,
        date: format(i.date, "D MMM YYYY"),
        smsCount: i.sms_count,
      };
    },
    transformChartData(i, k) {
      let day = new Date(i.date);
      day = day.getUTCDate();
      if (day > 1) {
        for (let c = 0; c < day; c++) {
          return {
            date: c, //format(i.date, "D MMM YYYY"),
            smsCount: c == k ? i.smsCount : 0,
          };
        }
      }
      return {
        date: day, //format(i.date, "D MMM YYYY"),
        smsCount: i.smsCount,
      };
    },
    showMore() {
      this.perPage = this.perPage + 10;
      this.getSmsReport({
        per_page: this.perPage,
        company_name: this.companyName,
      })
        .then((res) => {
          this.alerts = res.items.map(this.transformAlerts);
        })
        .catch((err) => console.log(err));
    },
    getSmsReports: async function () {
      this.loading = true;
      const from_date = this.interval.from;
      const to_date = this.interval.to;

      const date_gte =
        from_date.getFullYear() +
        "-" +
        format(from_date, "MM") +
        "-" +
        format(from_date, "DD");
      const date_lte =
        to_date.getFullYear() +
        "-" +
        format(to_date, "MM") +
        "-" +
        format(to_date, "DD");

      this.getSmsReport({
        per_page: this.interval.length,
        company_name: this.companyName,
        date_gte: date_gte,
        date_lte: date_lte,
      })
        .then((res) => {
          this.loading = false;
          this.alerts = res.items.map(this.transformAlerts);
        })
        .catch((err) => console.log(err));
    },
    selectedFrom: function (from) {
      this.interval.from = from;

      const millisInDay = 1000 * 60 * 60 * 24;

      const millisInMonth = 30 * millisInDay;

      this.interval.toDisabledDates.to = new Date(from.getTime() + millisInDay);

      if (
        from.getTime() + millisInMonth <=
        this.interval.fromDisabledDates.from.getTime()
      ) {
        this.interval.toDisabledDates.from = new Date(
          from.getTime() + millisInMonth
        );
      } else {
        this.interval.toDisabledDates.from = this.interval.fromDisabledDates.from;
      }

      if (
        this.interval.to.getTime() <
          this.interval.toDisabledDates.to.getTime() ||
        this.interval.to.getTime() >
          this.interval.toDisabledDates.from.getTime()
      ) {
        this.interval.to = this.interval.toDisabledDates.from;
      }

      this.getSmsReports();
    },
    selectedTo: function (to) {
      this.interval.to = to;
      this.getSmsReports();
    },
  },
};
</script>

<style lang="scss">
.dashboard-container {
  //padding: 16px;
  .chart-container {
    display: flex;
    margin-bottom: 20px;
    .search-container {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      .search-input {
        height: 36px;
        width: 417px;
      }
      .secondary-button {
        height: 36px;
        width: 80px;
      }
    }
    .resellers-table {
      height: 37px;
      display: flex;
      align-items: center;
      padding: 0 15px 0 15px;
      box-shadow: inset 0 -1px 0 0 #dfe3e8;
      div {
        width: 15%;
      }
    }
    .table-header {
      color: #212b36;
      font-family: "Helvetica Neue";
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
    }
    .table-body {
      color: #212b36;
      font-family: "Helvetica Neue";
      font-size: 14px;
      line-height: 20px;
      justify-content: left;
      .status {
        border: 2px solid #ffffff;
        border-radius: 100px;
        box-sizing: border-box;
        padding: 2px 8px 2px 8px;
        width: fit-content;
        font-family: "Helvetica Neue";
        font-size: 13px !important;
        line-height: 16px;
      }
    }
    .pagination-link {
      cursor: pointer;
      margin-top: 10px;
      text-align: center;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 13px;
      line-height: 15px;
    }
  }
  .select-interval {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .primary-input-title {
      min-width: 35px;
    }
    .from {
      /*margin-left: 290px;*/
      margin-right: 20px;
    }
    .primary-input-container {
      min-width: 270px;
      width: 35%;
      display: flex;

      p {
        color: #000000;
        font-family: "" Helvetica Neue "";
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.21px;
        line-height: 15px;
        margin-bottom: 0px;
        margin-right: 10px;
        padding: 12px 0;
        text-transform: uppercase;
      }
      .pimary-input-title {
        color: #000000;
        font-family: "" Helvetica Neue "";
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.21px;
        line-height: 15px;
        margin-bottom: 5px;
        margin-right: 10px;
        text-transform: uppercase;
      }
      .primary-select-wrapper {
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        background-color: #ffffff;

        ::placeholder {
          color: #55616e !important;
          opacity: 1;
        }
        .calendar-class {
          width: fit-content !important;
          height: fit-content !important;
          font-family: "Helvetica Neue";
          font-size: 14px;
        }
        .date-wrapper {
          width: 100%;
        }
        .vdp-datepicker {
          div {
            width: 100%;
          }
        }
        .date-picker {
          width: 100%;
          min-height: 40px;
          display: block;
          background: transparent;
          padding-left: 15px;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          border: none;
        }
        select:focus {
          border: 1px solid #51a3f3;
        }
        .icon-down {
          position: absolute;
          left: 100%;
          margin-left: -35px;
        }
      }
    }
  }
}
</style>